<template>
  <div class="equipOpenCount" ref="equipOpenCount">
    <div class="tab">
      <a class="home_tab" v-for="(item, i) in selectArr" :key="i" :class="{ home_tab_actived: selectIndex == i + 1 }" @click.stop="handleItem(i + 1)">{{ item.name }}</a>
      <el-select v-model="optionIndex" filterable placeholder="请选择" @change="change()">
        <el-option v-for="(item, i) in options" :key="i" :label="item.name" :value="item.num">
        </el-option>
      </el-select>
    </div>
    <div class="innerBox">
      <div class="charts">
        <!--div class="chart1" v-if="lineType">
          <div class="chart_line" ref="chart1"></div>
        </div-->
        <div class="chart2">
          <div class="chart_column" ref="chart2"></div>
        </div>
      </div>
      <div class="allCount">
        <div class="bg absolute_center"></div>
        <div class="circle"></div>
        <div class="today_all_count absolute_center">
          <div class="div1" v-text="getStaticType()"></div>
          <div class="div2 number">{{ "启:" + allCountOpen }}</div>
          <div class="div2 number">{{ "停:" + allCountStop }}</div>
          <div class="div3">次</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getOptLine from "./chartLine.js";
import getOptBar from "./chartBar.js";
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'equipOpenCount.vue',
      computedName: '设备启停统计组件',
      styleType: "",
      allCountOpen: 0,
      allCountStop: 0,
      unit: 2,
      customerId: this.$store.state.customerId,
      chart2: null,
      selectIndex: 0,
      selectArr: [
        { name: "日" },
        { name: "周" },
        { name: "月" },
        { name: "年" },
      ],
      optionIndex: 1,
      options: [
        { name: "生产设备", num: 1 },
        { name: "治理设备", num: 2 },
      ],
    };
  },
  //计算属性 类似于data概念
  computed: {
    getStaticType() {
      return function () {
        let typeName = "";
        if (this.selectIndex === 1) {
          typeName = "日累计";
        } else if (this.selectIndex === 2) {
          typeName = "周累计";
        } else if (this.selectIndex === 3) {
          typeName = "月累计";
        } else if (this.selectIndex === 4) {
          typeName = "年累计";
        }
        return typeName;
      };
    },
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType;
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.equipOpenCount).outerWidth();
    let h = $(that.$refs.equipOpenCount).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.handleItem(1);
    this.typeChange();
  },
  //方法集合
  methods: {
    handleItem(index) {
      this.selectIndex = index;
      this.getData();
    },
    async getData() {
      let that = this;
      let deviceRunCountUrl = CONFIG.requestName + this.$apiOpt.deviceRunCount;
      let data = await that.$apiUtils.get(deviceRunCountUrl, {
        customerId: that.customerId,
        type: that.optionIndex,
        timeType: that.selectIndex,
      });
      let sumTimeOpen = data?.open;
      this.allCountOpen = parseInt(sumTimeOpen);
      let sumTimeStop = data?.stop;
      this.allCountStop = parseInt(sumTimeStop);
      let runTimeList = data?.list;
      if (that.selectIndex === 1) {
        let result = that.convertListByHour(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 2) {
        let result = that.convertListByWeek(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 3) {
        let result = that.convertListByMonth(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 4) {
        let result = that.convertListByYear(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      }
      //alert(2222222222222222);
    },
    convertListByHour(list) {
      let resultOpen = {
        "0:00": 0,
        "4:00": 0,
        "8:00": 0,
        "12:00": 0,
        "16:00": 0,
        "20:00": 0,
      };
      let resultClose = {
        "0:00": 0,
        "4:00": 0,
        "8:00": 0,
        "12:00": 0,
        "16:00": 0,
        "20:00": 0,
      };
      let resultObj = {};
      list.forEach((element) => {
        let tmpTime = element.time;
        if (tmpTime) {
          let tmpHour = new Date(
            tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
          ).getHours();
          if (tmpHour < 4) {
            resultOpen["0:00"] += parseFloat(element.open);
            resultClose["0:00"] += parseFloat(element.stop);
          } else if (tmpHour < 8) {
            resultOpen["4:00"] += parseFloat(element.open);
            resultClose["4:00"] += parseFloat(element.stop);
          } else if (tmpHour < 12) {
            resultOpen["8:00"] += parseFloat(element.open);
            resultClose["8:00"] += parseFloat(element.stop);
          } else if (tmpHour < 16) {
            resultOpen["12:00"] += parseFloat(element.open);
            resultClose["12:00"] += parseFloat(element.stop);
          } else if (tmpHour < 20) {
            resultOpen["16:00"] += parseFloat(element.open);
            resultClose["16:00"] += parseFloat(element.stop);
          } else {
            resultOpen["20:00"] += parseFloat(element.open);
            resultClose["20:00"] += parseFloat(element.stop);
          }
        }
      });
      resultObj.time = [];
      resultObj.openVal = [];
      resultObj.closeVal = [];
      for (let i in resultOpen) {
        resultObj.time.push(i);
        resultObj.openVal.push(resultOpen[i]);
        resultObj.closeVal.push(resultClose[i]);
      }
      return resultObj;
    },
    convertListByWeek(list) {
      /*let weekFirstDay = new Date(
        new Date() - (new Date().getDay() - 1) * 86400000
      ).getTime();*/
      let resultObj = {};
      resultObj.time = [];
      resultObj.openVal = [];
      resultObj.closeVal = [];
      list.forEach((item) => {
        let key = new Date(item.time.replace(/-0/g, "/").replace(/-/g, "/"));
        resultObj.time.push(key.getMonth() + 1 + "-" + key.getDate());
        resultObj.openVal.push(item.open);
        resultObj.closeVal.push(item.stop);
      });
      return resultObj;
    },
    convertListByMonth(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = month + "-1";
      let week2 = month + "-8";
      let week3 = month + "-15";
      let week4 = month + "-22";
      let resultOpen = {};
      resultOpen[week1] = 0;
      resultOpen[week2] = 0;
      resultOpen[week3] = 0;
      resultOpen[week4] = 0;
      let resultClose = {};
      resultClose[week1] = 0;
      resultClose[week2] = 0;
      resultClose[week3] = 0;
      resultClose[week4] = 0;
      let resultObj = {};
      list.forEach((element) => {
        let tmpTime = element.time;
        if (tmpTime) {
          let tempTs = new Date(
            tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
          ).getTime();
          if (
            tempTs < new Date((year + "-" + week2).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week1] += parseFloat(element.open);
            resultClose[week1] += parseFloat(element.close);
          } else if (
            tempTs < new Date((year + "-" + week3).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week2] += parseFloat(element.open);
            resultClose[week2] += parseFloat(element.stop);
          } else if (
            tempTs < new Date((year + "-" + week4).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week3] += parseFloat(element.open);
            resultClose[week3] += parseFloat(element.stop);
          } else {
            resultOpen[week4] += parseFloat(element.open);
            resultClose[week4] += parseFloat(element.stop);
          }
        }
      });
      resultObj.time = [];
      resultObj.openVal = [];
      resultObj.closeVal = [];
      for (let i in resultOpen) {
        resultObj.time.push(i);
        resultObj.openVal.push(resultOpen[i]);
        resultObj.closeVal.push(resultClose[i]);
      }
      return resultObj;
    },
    convertListByYear(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = "一季度";
      let week2 = "二季度";
      let week3 = "三季度";
      let week4 = "四季度";
      let week1_ = "4-1";
      let week2_ = "7-1";
      let week3_ = "10-1";
      let resultOpen = {};
      resultOpen[week1] = 0;
      resultOpen[week2] = 0;
      resultOpen[week3] = 0;
      resultOpen[week4] = 0;
      let resultClose = {};
      resultClose[week1] = 0;
      resultClose[week2] = 0;
      resultClose[week3] = 0;
      resultClose[week4] = 0;
      let resultObj = {};
      list.forEach((element) => {
        let tmpTime = element.time;
        if (tmpTime) {
          let tempTs = new Date(
            tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
          ).getTime();
          if (
            tempTs < new Date((year + "-" + week1_).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week1] += parseFloat(element.open);
            resultClose[week1] += parseFloat(element.stop);
          } else if (
            tempTs < new Date((year + "-" + week2_).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week2] += parseFloat(element.open);
            resultClose[week2] += parseFloat(element.stop);
          } else if (
            tempTs < new Date((year + "-" + week3_).replace(/-/g, "/")).getTime()
          ) {
            resultOpen[week3] += parseFloat(element.open);
            resultClose[week3] += parseFloat(element.stop);
          } else {
            resultOpen[week4] += parseFloat(element.open);
            resultClose[week4] += parseFloat(element.stop);
          }
        }
      });
      resultObj.time = [];
      resultObj.openVal = [];
      resultObj.closeVal = [];
      for (let i in resultOpen) {
        resultObj.time.push(i);
        resultObj.openVal.push(resultOpen[i]);
        resultObj.closeVal.push(resultClose[i]);
      }
      return resultObj;
    },
    change() {
      this.getData();
    },
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {
          $(".equipOpenCount .tab").css("margin-top", "20px");
          $(".equipOpenCount .innerBox").css("height", "170px");
        });
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {
          $(".equipOpenCount .tab").css("margin-top", "initial");
          $(".equipOpenCount .innerBox").css("height", "180px");
        });
      }
    },
  },
  unmounted() {
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
  },
};
</script>
<style lang="scss" scoped="scoped">
.equipOpenCount {
  width: 600px;
  height: 250px;
  .tab {
    justify-content: flex-end;
    z-index: 1;
    display: flex;
    .el-select {
      width: 125px;
      height: 26px;
    }
  }
  .innerBox {
    @include bg-box(560px, 180px, "imgBg.png");
    display: flex;
    margin-top: 6px;
    padding-left: 10px;

    .charts {
      width: 340px;
      height: 100%;
      margin-right: 10px;
      // padding: 20px 0px 0px;
      .chart1 {
        width: 100%;
        height: 100%;
        .chart_line {
          width: 100%;
          height: 100%;
        }
      }
      .chart2 {
        width: 100%;
        height: 100%;
        .chart_column {
          width: 100%;
          height: 100%;
        }
      }
    }
    .allCount {
      width: 200px;
      height: 100%;
      position: relative;
      .bg {
        position: absolute;
        @include bg-box(90px, 92px, "flowerBg.png");
      }
      .circle {
        @include bg-box(164px, 164px, "circle.png");
        top: 7px;
        left: 18px;
        position: absolute;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-180deg);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
      .today_all_count {
        width: 65px;
        height: 85px;
        text-align: center;
        padding-top: 5px;
        .div1 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }
        .div2 {
          width: 100%;
          height: 18px;
          font-size: 16px;
          color: #99f5ff;
          line-height: 18px;
        }
        .div3 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
        }
      }
    }
  }
}
</style>
<style>
.equipOpenCount .el-select {
  margin-left: 5px;
  height: 26px;
}
.equipOpenCount .el-select .select-trigger {
  height: 26px !important;
}
.equipOpenCount .el-select .select-trigger .el-input {
  height: 26px;
}
.equipOpenCount .el-select .select-trigger .el-input .el-input__inner {
  height: 26px !important;
}
.equipOpenCount .home_tab {
  margin-left: 10px;
}
</style>
